import React from "react";
import PropTypes from "prop-types";

const calculateTime = (time) => {
  const hours = Math.floor(time / 60);
  const remainingMinutes = time % 60;
  return { hours, remainingMinutes };
};

const ShowTimeInHoursAndMins = ({ time, calculated, returnText = false }) => {
  if (time === undefined || time === null) {
    return returnText ? "" : <span></span>;
  }

  const { hours, remainingMinutes } = calculateTime(parseInt(time));

  // If returnText is true, return formatted string
  if (returnText) {
    if (hours === 0) {
      return `${remainingMinutes}m`;
    }

    if (remainingMinutes === 0) {
      return `${hours}h`;
    }

    return `${hours}h ${remainingMinutes}m`;
  }

  // Original JSX rendering
  const style = calculated
    ? { marginLeft: ".3em", whiteSpace: "nowrap" }
    : { whiteSpace: "nowrap" };

  if (hours === 0) {
    return <span style={style}>{remainingMinutes}m</span>;
  }

  if (remainingMinutes === 0) {
    return <span style={style}>{hours}h </span>;
  }

  return (
    <span style={style}>
      {hours}h {remainingMinutes}m
    </span>
  );
};

ShowTimeInHoursAndMins.propTypes = {
  time: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  calculated: PropTypes.bool,
  returnText: PropTypes.bool,
};

export default ShowTimeInHoursAndMins;
